import {Component, OnInit} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import {Http} from '@angular/http';
import {getHttpHeadersOrInit, HttpInterceptorService} from 'ng-http-interceptor';
import {AuthService} from './auth/auth.service';
import {Router} from '@angular/router';
import {WindowRef} from "app/shared/WindowRef";
import {AlertService} from "./shared/alert/alert.service";
import {Alert} from "./shared/alert/Alert";
import {environment} from "../environments/environment";

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {

  title = 'app';

  constructor(private router: Router, translate: TranslateService, http: Http,
              httpInterceptor: HttpInterceptorService, private authService: AuthService, alertService: AlertService) {
    // this language will be used as a fallback when a translation isn't found in the current language
    translate.setDefaultLang('en');

    // the lang to use, if the lang isn't available, it will use the current loader to get them
    translate.use('en');

    httpInterceptor.request().addInterceptor((data, method) => {

      const headers = getHttpHeadersOrInit(data, method);

      if (this.authService.isAuthenticated()) {
        headers.set('Authorization', 'Bearer ' + this.authService.getCurrentUserToken());
      }

      return data;
    });


    httpInterceptor.response().addInterceptor(res => {

      return res.do(
        null,
        r => {

        if (r.status === 400 || r.status === 401) {
          alertService.danger(new Alert('Please log in!'));
          this.router.navigate(['/login']);
        } else if (r.status === 403) {
          this.router.navigate(['/not-authorized']);
        }

        if (r.status >= 500 && r.status < 600) {
          alertService.danger(new Alert('Something went wrong, please come back later.'));
        }
      });
    });
  }

  ngOnInit() {
    // Send the user to the auth screen if he is not authenticated
    if (!this.authService.isAuthenticated() && !window.location.href.includes('/auth/validate') && environment.production === true) {
      this.authService.redirectToAuthScreen();
    }
  }

  isFullScreen() {
    if (this.router.url.startsWith('/user/') || this.router.url.startsWith('/storyboard/') || this.router.url.startsWith('/template/') ||
        this.router.url.startsWith('/storyboard-publish/')) {
      return true;
    }

    return false;
  }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts